export enum PlanSubscriptionPeriodEnum {
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}
